/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { createSelector } from "reselect";

// --- for 1) Posts of a course, 2) Comments of a post
// ----------------------------------------------------------------------

// Functions to retrieve piece of state
const queryPosts = (state: any, props: any) => props.course;
const queryComments = (state: any, props: any) => props.pid;

const dataCourse = (state_posts: any) => state_posts.course;
const dataPosts = (state_posts: any) => state_posts.posts;
const dataPostId = (state_posts: any) => state_posts.postId;
const dataComments = (state_posts: any) => state_posts.comments;

// Selector consumed by components
export const selectorPosts = createSelector([dataPosts], (posts) => posts);
export const selectorComments = createSelector([dataComments], (cmts) => cmts);

// Selector consumed by action creator to check if the posts of requested course is loaded
// Usage:  postsLoaded(piece_of_state, props)
// Example: if (postsLoaded(getState(), { course }))
//
// [queryPosts, dataCourse] are two functions that retrieve...
//  1. 'course' from props, as requested_course
//  2. course from state, as course
// In this case, we returns true/false only
export const postsLoaded = createSelector(
  [queryPosts, dataCourse],
  (requested_course, course) => requested_course === course,
);

export const commentsLoaded = createSelector(
  [queryComments, dataPostId],
  (requested_pid, postId) => requested_pid === postId,
);
